import { Validator } from "./types";
import { SearchContextType } from "../search-context";
import ValidationErrorMessages from "./error-messages";

const validatePersonSearch: Validator = (data: SearchContextType) => {
  const {
    firstName,
    lastName,
    emailAddress,
    nationalInsuranceNumber,
    drivingLicenseNumber,
    passportNumber,
    registrationNumber,
    vinNo,
    telNo,
    mobileTelNo,
    fullAddress,
    dateOfBirth,
  } = data;

  const hasForename = (firstName?.trim().length ?? 0) > 1;
  const hasSurname = (lastName?.trim().length ?? 0) > 0;
  const hasDob = !!dateOfBirth?.toString().trim();
  const hasFullAddress = !!fullAddress?.trim();

  const hasOtherIdentifiers =
    emailAddress?.trim() ||
    nationalInsuranceNumber?.trim() ||
    drivingLicenseNumber?.trim() ||
    passportNumber?.trim() ||
    registrationNumber?.trim() ||
    vinNo?.trim() ||
    telNo?.trim() ||
    mobileTelNo?.trim();

  if (
    hasForename &&
    hasSurname &&
    (hasOtherIdentifiers || (hasDob && hasFullAddress))
  ) {
    return { isValid: true, errors: [] };
  }

  if (!hasForename && !hasSurname) {
    return { isValid: false, errors: [] };
  }

  if ((hasForename && !hasSurname) || (!hasForename && hasSurname)) {
    return {
      isValid: false,
      errors: [ValidationErrorMessages.invalidPerson],
    };
  }

  if (!hasForename || !hasSurname) {
    return { isValid: false, errors: [ValidationErrorMessages.invalidPerson] };
  }

  return { isValid: false, errors: [ValidationErrorMessages.invalidPerson] };
};

export default validatePersonSearch;
